﻿

	 import { SearchFilter } from '@models/search-filters/SearchFilter';
    
    export class PlaceSearchFilter extends SearchFilter {
        
        
        id?: number | null;
    }
